import React, { useState } from 'react';

const FTableGenerator = () => {
  const [startDf1, setStartDf1] = useState(1);
  const [endDf1, setEndDf1] = useState(5);
  const [df2, setDf2] = useState(5);
  const [fTable, setFTable] = useState([]);

  // Placeholder function to calculate F-values (replace with actual formula or data)
  const calculateFValue = (df1, df2, alpha) => {
    return ((df1 + df2) / df1) * Math.abs(Math.log(alpha)).toFixed(4); // Approximation for demonstration
  };

  const generateFTable = () => {
    if (startDf1 < 1 || endDf1 > 100 || startDf1 > endDf1 || df2 < 1 || df2 > 100) {
      alert("Please enter valid degrees of freedom (1 to 100) and ensure startDf1 <= endDf1.");
      return;
    }

    const table = [];
    for (let df1 = startDf1; df1 <= endDf1; df1++) {
      table.push({
        df1,
        alpha_0_10: calculateFValue(df1, df2, 0.10),
        alpha_0_05: calculateFValue(df1, df2, 0.05),
        alpha_0_01: calculateFValue(df1, df2, 0.01),
      });
    }
    setFTable(table);
  };

  return (
    <div>
      <h2>F-Distribution Table Generator</h2>
      <label htmlFor="startDf1">Start \( df_1 \) (1-100): </label>
      <input
        type="number"
        id="startDf1"
        min="1"
        max="100"
        value={startDf1}
        onChange={(e) => setStartDf1(parseInt(e.target.value))}
      />
      <br />
      <label htmlFor="endDf1">End \( df_1 \) (1-100): </label>
      <input
        type="number"
        id="endDf1"
        min="1"
        max="100"
        value={endDf1}
        onChange={(e) => setEndDf1(parseInt(e.target.value))}
      />
      <br />
      <label htmlFor="df2">Degrees of Freedom \( df_2 \) (1-100): </label>
      <input
        type="number"
        id="df2"
        min="1"
        max="100"
        value={df2}
        onChange={(e) => setDf2(parseInt(e.target.value))}
      />
      <br />
      <button onClick={generateFTable}>Generate Table</button>

      {fTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>\( df_1 \)</th>
              <th>F (α = 0.10)</th>
              <th>F (α = 0.05)</th>
              <th>F (α = 0.01)</th>
            </tr>
          </thead>
          <tbody>
            {fTable.map((row, index) => (
              <tr key={index}>
                <td>{row.df1}</td>
                <td>{row.alpha_0_10}</td>
                <td>{row.alpha_0_05}</td>
                <td>{row.alpha_0_01}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default FTableGenerator;
